import React, { useEffect } from 'react'
import { withFormik, Form, Field } from 'formik'
import { Link } from 'react-router-dom'
import { forgotUsername, sendUsername } from '../utils/authService';
import { withTranslation } from 'react-i18next';

const validate = (values, props) => {
  let errors = {};

  if (!values.email) {
    errors.email = props.t('emailRequired');
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,5}$/i.test(values.email)) {
    errors.email = props.t('invalidEmail');
  }

  return errors;
};

const ForgotUsernameComponent = (props) => {
  const {
    values,
    handleChange,
    dirty,
    errors,
    t,
    touched,
    isSubmitting
  } = props

  useEffect(() => {
    document.title = 'City of Seattle | Forgot Username'
  }, [])

    function getParameterByName(name, url = window.location.href) {
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }

    values.appName = getParameterByName('appName');
    values.appName = values.appName.replace(/\//g, '');
    var link = '/login?appName=' + values.appName;

  return (
    <div>
      <h2>{t("forgotUsername")}</h2>
      <p>{t('forgotUsernameInstructions')}</p>
      <Form className="App-form">

        <div className={"form-group form-group-lg " + (errors.email && touched.email ? 'has-error' : '')}>
          <label htmlFor="email" className="control-label">{t('email')} <span className="text-danger">*</span></label>
          <Field type="email" className="form-control" name="email" value={values.email} onChange={handleChange} />
          {errors.email && touched.email && <div className="text-danger" role="alert">
            <span className="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span>
            <span className="sr-only">Error:</span>
            {touched.email && errors.email}
          </div>}
        </div>


        <button type="submit" className="btn btn-primary btn-lg btn-block" disabled={!dirty || isSubmitting}>{t('submit')}</button>
      </Form>
      <div className="return-link">
              <Link to={ link }>{t('returnLogin')}</Link>
      </div>
    </div>
  )
}

const ForgotUsername = withFormik({
  mapPropsToValues({ email }) {
    return {
      email: email || ''
    }
  },
  validate: validate,
  handleSubmit(values, { props, setSubmitting }) {
    const params = { "email": values.email };
    const registrationUrl = window.location.origin + '/#/registration';

    forgotUsername(params)
      .then(response => {
          if (response.data) {
              let userName = response.data.Resources[0].userName;
              let appName = values.appName;

              let credentials = { userName, appName };
            console.log(credentials);
          sendUsername(credentials).then(response => {
            props.setSendPasswordEmail(userName);
          }).catch(error => {
            props.showNotification({
              type: 'failure',
              title: props.t('forgotPasswordFailedTitle'),
              message: props.t('forgotPasswordFailed')
            }
            );
          })
            .finally(() => {
              setSubmitting(false);
            });

          props.showNotification({
            type: 'success',
            title: props.t('forgotUsernameSuccessTitle'),
            message: props.t('forgotUsernameSuccess')
          });
        } else {
          props.showNotification({
            type: 'failure',
            title: props.t('forgotUsernameFailedTitle'),
            message: props.t('forgotUsernameFailed'),
            link: registrationUrl,
            linkText: props.t('forgotUsernameFailedLinkText'),
            linkSuffix: props.t('forgotUsernameFailedLinkTextSuffix')
          });
        }
      })
      .catch(error => {
        props.showNotification({
          type: 'failure',
          title: props.t('forgotUsernameFailedTitle'),
          message: props.t('forgotUsernameFailed'),
          link: registrationUrl,
          linkText: props.t('forgotUsernameFailedLinkText'),
          linkSuffix: props.t('forgotUsernameFailedLinkTextSuffix')
        });
      })
      .finally(() => {
        setSubmitting(false);
      });
  }
})(ForgotUsernameComponent)

export default withTranslation()(ForgotUsername);
